import React, { Fragment, Component } from 'react'
import CommonEnrolmentFields from './common-fields'

class RaFields extends Component {
  render() {
    return (
      <Fragment>
        An arrangement between the provider and individual for the care of a child that does not
        meet the full requirments for a Complying Written Agreement.
        <CommonEnrolmentFields {...this.props} />
      </Fragment>
    )
  }
}

export default RaFields



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/create-enrolment/ra-fields.js